import { AlertsService } from 'app/services/system/alerts/alerts.service';

export function copyLink(value, message = 'Hlekkur afritaður', alertsService: AlertsService = null) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    try {
        alertsService.changeAlertShowIcon(false);
        alertsService.changeAlertSuccessMessage(message);
        alertsService.changeAlertSuccessShow(true);
    } catch {}
}
